<template src="@/templates/portal/dashboard.html"></template>

<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';

export default {
  data() {
    return {
      user: {},
      upcomingRes: {
        travel_package: {},
        departure: {},
        partner: {},
        entity: {},
      },
      isLoadingUser: true,
      isLoadingReservation: true,
      entity: entityStore.state,
    };
  },
  computed: {
    pageTitle() {
      const name = entityStore.formatPassengerName(this.user);
      let prefix = 'Welkom';
      if (entityStore.state.name === 'amigo') {
        prefix = 'Hoi';
      } else {
        const genderPrefix = entityStore.getGenderPrefix(this.user);

        prefix = `Geachte ${genderPrefix}`;
      }
      const pageTitle = `${prefix} ${name}`;
      return pageTitle;
    },
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      this.isLoadingUser = true;
      this.isLoadingReservation = true;
      userApi.getUser((data) => {
        this.user = data.user;
        this.isLoadingUser = false;
      });
      userApi.getUpcomingReservation((data) => {
        this.upcomingRes = data.upcoming_reservation;
        this.isLoadingReservation = false;
      });
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// dashboard.vue?a537abb8